import { jwtDecode } from 'jwt-decode'
import { IToken } from 'models/interfaces'
import React from 'react'
import { useLayoutEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import Login from 'routes/LoginView/LoginView'
import { getLocalStorageToken } from 'store/localStorage'
import { AppState } from 'models/AppState'
import {
  LOGIN_UPDATE_TOKEN,
  LOGIN_REMOVE_TOKEN,
  LOGIN_SUBMIT,
  LOGIN_ERROR,
} from './loginReducer'

export interface ILoginContainerProps {
  SSO: boolean
  emailLogin: boolean
}

export interface ILoginProps {
  SSO: boolean
  emailLogin: boolean
  loginError: boolean
  loggingIn: boolean
  login: (token: string) => void
  logout: () => void
  loginSubmit: () => void
  authenticationError: (error: string) => void
}

const LoginContainer: React.FC<ILoginContainerProps> = ({ SSO, emailLogin }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const loginError = useSelector((state: AppState) => state.login.loginError)
  const loggingIn = useSelector((state: AppState) => state.login.loggingIn)
  const token = useSelector((state: AppState) => state.login.token)

  const login = (tokenValue: string) => dispatch({ type: LOGIN_UPDATE_TOKEN, payload: tokenValue })
  const logout = () => dispatch({ type: LOGIN_REMOVE_TOKEN })
  const loginSubmit = () => dispatch({ type: LOGIN_SUBMIT })
  const authenticationError = (error: string) => dispatch({ type: LOGIN_ERROR, payload: error })

  const isTokenOld = (decodedToken: IToken) => {
    const expDate = new Date(decodedToken.exp * 1000)
    return Date.now() >= expDate.valueOf()
  }

  useLayoutEffect(() => {
    const storedToken = getLocalStorageToken()
    try {
      const decodedToken: IToken = jwtDecode(storedToken)
      if (isTokenOld(decodedToken)) {
        logout()
      } else {
        navigate('/', { replace: true })
      }
    } catch (err) {
      //
    }
  }, [navigate, token])

  return (
    <Login
      SSO={SSO}
      emailLogin={emailLogin}
      loginError={loginError}
      loggingIn={loggingIn}
      login={login}
      logout={logout}
      loginSubmit={loginSubmit}
      authenticationError={authenticationError}
    />
  )
}

export default LoginContainer
